module.exports = __webpack_public_path__ + "static/media/Johel_round.71795a21.jpg";